import { useLayoutEffect, useState } from 'react';

// Where a popover of this size opens next to the element in ref, once open: below it unless only the space
// above has room, and stretching left from its right edge unless that leaves the window.
export function usePopoverPlacement(ref, isOpen, width, height) {
    const [placement, setPlacement] = useState({ above: false, alignLeft: false });

    useLayoutEffect(() => {
        if (!isOpen || !ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const below = window.innerHeight - rect.bottom;
        setPlacement({
            above: below < height && rect.top > below,
            alignLeft: rect.right - width < 0,
        });
    }, [isOpen, ref, width, height]);

    return placement;
}

// Reads and writes a per-browser preference, such as recent emojis; storage may be unavailable.
export const readPreference = (key, fallback) => {
    try {
        const value = JSON.parse(localStorage.getItem(key));
        return value ?? fallback;
    } catch {
        return fallback;
    }
};

export const writePreference = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // Without storage the preference lasts until the page closes.
    }
};
